import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DistributionComponent } from "../distribution/distribution.component";
import {
  FormsModule as AngularFormsModule,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { ChartsModule } from "ng2-charts";
import { ModalModule } from "ngx-bootstrap/modal";
import { BsDatepickerModule } from "ngx-bootstrap";
import { AgmCoreModule } from "@agm/core";
import { SelectModule } from "ng-select";

import { FilterProductsModule } from "../../../../layout/filter-products/filter-products.module";
import {
  ConfirmationService,
  ConfirmDialogModule,
  GrowlModule,
  TooltipModule,
} from "primeng/primeng";
import { ImageService } from "../../../imageService";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AngularFormsModule,
    ChartsModule,
    FilterProductsModule,
    ModalModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyC0fgs5qkpOIDJRXBNG8mNApwwFk30qhMs",
    }),
    SelectModule,
    BsDatepickerModule.forRoot(),
    TooltipModule,
  ],
  declarations: [DistributionComponent],
})
export class DistributionModule {}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/distribution/distribution.module.ts